import React from 'react';
import { engagementModels } from '../mock';
import { ArrowRight } from 'lucide-react';

export default function Engagement() {
  return (
    <section id="engagement" className="relative bg-[#0B1F2D] text-[#FAFAF5] overflow-hidden">
      <div className="absolute inset-0 grain opacity-30" />
      <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-[#1B6F5E]/15 blur-3xl" />

      <div className="relative max-w-[1320px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-5">
            <div className="text-[11.5px] tracking-[0.16em] uppercase text-[#7BC2B0] font-medium">
              Engagement models
            </div>
            <h2 className="mt-3 font-display text-[40px] lg:text-[56px] leading-[1.02]">
              Scoped to your
              <br />
              <span className="italic text-[#7BC2B0]">filing reality.</span>
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-3">
            <p className="text-[16.5px] leading-[1.6] text-[#FAFAF5]/70 max-w-[640px]">
              ESGine® is offered as a secure, access-controlled platform. We do not publish pricing online. Every
              engagement is scoped based on filing complexity, applicable frameworks, and internal teams involved.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {engagementModels.map((m, i) => (
            <div
              key={m.n}
              className={`rounded-2xl p-8 border transition-colors duration-300 ${
                i === 1
                  ? 'bg-[#FAFAF5] text-[#0B1F2D] border-[#FAFAF5]'
                  : 'bg-white/[0.04] border-white/10 hover:border-[#7BC2B0]/40'
              }`}
            >
              <div className="flex items-center justify-between">
                <div
                  className={`font-mono-tight text-[12px] tracking-[0.12em] ${
                    i === 1 ? 'text-[#0B1F2D]/55' : 'text-[#FAFAF5]/55'
                  }`}
                >
                  /{m.n}
                </div>
                {i === 1 && (
                  <span className="text-[10.5px] tracking-[0.12em] uppercase bg-[#0B1F2D] text-[#FAFAF5] px-2 py-1 rounded-full">
                    Most chosen
                  </span>
                )}
              </div>
              <div className="mt-7 font-display text-[26px] leading-[1.15]">{m.title}</div>
              <p
                className={`mt-4 text-[14px] leading-[1.6] ${
                  i === 1 ? 'text-[#0B1F2D]/65' : 'text-[#FAFAF5]/65'
                }`}
              >
                {m.desc}
              </p>
              <div
                className={`mt-6 pt-5 border-t text-[12.5px] leading-[1.5] ${
                  i === 1
                    ? 'border-[#E8E5DC] text-[#0B1F2D]/55 italic'
                    : 'border-white/10 text-[#FAFAF5]/55 italic'
                }`}
              >
                {m.note}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 rounded-2xl border border-white/10 bg-white/[0.03] px-7 py-6">
          <p className="text-[14.5px] text-[#FAFAF5]/75 max-w-[640px]">
            No public pricing. Every engagement is scoped to your regulatory context, timelines and internal teams.
          </p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 bg-[#FAFAF5] text-[#0B1F2D] rounded-full h-11 px-5 text-[13px] font-medium hover:bg-[#7BC2B0] transition-colors"
          >
            Request scoped proposal <ArrowRight className="w-3.5 h-3.5" />
          </a>
        </div>
      </div>
    </section>
  );
}
